import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ['selectedAction', 'actionButton']
  static values = { signupPdfLink: String }

  connect() {
    // console.log('connect admin corporation show')
    this.setActionButtonHref()
  }

  changeOption(event) {
    event.preventDefault()
    this.setActionButtonHref()
  }

  setActionButtonHref() {
    const url = new URL(this.signupPdfLinkValue)
    const params = url.searchParams
    params.delete('locale')
    params.append('locale', this.selectedActionTarget.value)
    this.actionButtonTarget.href = url.href
  }
}
